import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    work_order_note: {
      ...jsConn.formParams,
    },
  };
};

const itemDetails = {
  pluralName: "work_order_notes",
  singularName: "work_order_note",
};

async function needWorkOrderNotes(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    return Promise.resolve(jsConn);
  });
}

async function createWorkOrderNote(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .createItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      return Promise.resolve(jsConn);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function deleteWorkOrderNote(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api
    .deleteItem(jsConn, itemDetails)
    .then(jsConn => {
      return Promise.resolve(jsConn);
    })
    .catch(jsConn => {
      return Promise.reject(jsConn);
    });
}

export const workOrderNotesController = {
  createWorkOrderNote,
  needWorkOrderNotes,
  deleteWorkOrderNote,
};
